import { Injectable } from '@angular/core';

export function recarregarSeOrigemArwDoSemEnvConfig(hashFragments?: string[], caller?: string): boolean {
  const windowRef = typeof window !== 'undefined' ? (window as any) : undefined;

  if (!windowRef) {
    return false;
  }

  const reloadKey = 'acordo-ressarcimento-arw-do-reload';
  const originUrlKey = 'acordo-ressarcimento-arw-do-origin-url';
  const fragments = Array.isArray(hashFragments) ? hashFragments : [];
  const hasProfile = !!(windowRef.envConfig && windowRef.envConfig.profile);
  const currentPage = windowRef.location ? windowRef.location.href : '';
  const referrer = document.referrer || '';
  const reloadKeyValue = windowRef.sessionStorage.getItem(reloadKey);
  const currentArwDoUrl = currentPage.indexOf('/resplusweb/arw.do') !== -1
    ? currentPage
    : (referrer.indexOf('/resplusweb/arw.do') !== -1 ? referrer : '');
  let storedArwDoUrl = windowRef.sessionStorage.getItem(originUrlKey) || '';

  if (currentArwDoUrl) {
    windowRef.sessionStorage.setItem(originUrlKey, currentArwDoUrl);
    storedArwDoUrl = currentArwDoUrl;
  }

  const canReloadCurrentPage = !reloadKeyValue || reloadKeyValue !== currentPage;
  const callerId = caller || currentPage;
  const hashMatch = fragments.length === 0 || fragments.some(fragment => currentPage.indexOf(fragment) !== -1 || windowRef.location.hash.indexOf(fragment) !== -1);

  console.log('[ARW-DO][TS] entrou na funcao');
  console.log('[ARW-DO][TS] caller:', callerId);
  console.log('[ARW-DO][TS] pagina atual:', currentPage);
  console.log('[ARW-DO][TS] originUrlKey:', originUrlKey);
  console.log('[ARW-DO][TS] reloadKey:', reloadKey);
  console.log('[ARW-DO][TS] sessionStorage value:', reloadKeyValue);
  console.log('[ARW-DO][TS] url completa arw.do atual:', currentArwDoUrl);
  console.log('[ARW-DO][TS] url completa arw.do armazenada:', storedArwDoUrl);
  console.log('[ARW-DO][TS] canReloadCurrentPage:', canReloadCurrentPage);
  console.log('[ARW-DO][TS] hasProfile:', hasProfile);
  console.log('[ARW-DO][TS] hashMatch:', hashMatch);
  console.log('[ARW-DO][TS] referrer:', referrer);

  const shouldReload =
    (
      currentPage.indexOf('/resplusweb/arw.do') !== -1 ||
      referrer.indexOf('/resplusweb/arw.do') !== -1 ||
      hashMatch
    ) &&
    !hasProfile &&
    canReloadCurrentPage;

  console.log('[ARW-DO][TS] shouldReload:', shouldReload);

  if (!shouldReload) {
    if (hasProfile) {
      console.log('[ARW-DO][TS] removendo chave do sessionStorage:', reloadKey);
      windowRef.sessionStorage.removeItem(reloadKey);
    }
    return false;
  }

  console.log('[ARW-DO][TS] iniciando reload para:', callerId);
  windowRef.sessionStorage.setItem(reloadKey, currentPage);
  windowRef.location.reload();
  return true;
}

@Injectable({ providedIn: 'root' })
export class ArwDoReloadService {
  recarregarSeOrigemArwDoSemEnvConfig(hashFragments?: string[], caller?: string): boolean {
    return recarregarSeOrigemArwDoSemEnvConfig(hashFragments, caller);
  }
}